import React, {
  useState,
  useEffect,
  useImperativeHandle,
  forwardRef,
  useMemo,
  useRef,
} from "react";
import {
  Card,
  TextBox,
  Button,
  Select,
  IconInfo,
  TextArea,
  RadioGroup,
  RadioButton,
  useToast,
  FilePicker,
  Search,
  ProgressIndicator,
  DatePicker,
  InlineNotification,
  IconCurrency,
} from "@veneer/core";
import { Container, Row, Col, Tooltip } from "react-bootstrap";
import { toast } from "react-toastify";
import { useAppSelector, useAppDispatch } from "@store/hooks";
import { setFormData } from "@store/actions/case-deatis-form-actions";
import { apiGet, apiGetWithHeader, apiPost } from "@services/service";
// import { apiPost } from "@services/service";
import type { RootState } from "@store/store";
import { POST_BIND_APP_VER, POST_BIND_APP_VER2 } from "@constants/end-points";
import {
  defaultCaseDeatilsFormDetails,
  FileData,
  submitFormRef,
} from "@constants/case-create";

// import { setTotalUploadFiles } from '@store/actions/file-upload-actions';

import "./case-details.scss";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";
import {
  getFieldError,
  IsAlphabeticCharactersSpacesHyphen,
  isContainsLettersNumbersSpaces,
  isContainsLettersNumbersSpacesCaseTitle,
  onSearchDropDown,
  scrollToErrorField,
} from "utils";
import { Trans, useTranslation } from "react-i18next";
import { setuid } from "process";
import { GET_STATIC_INTENT, POST_UEFI_CODE, POST_UIDS_ISSUE_DSC } from "services";
import CaseContact from "../case-contact/case-contact";
import { isError } from "util";
import { Icon123 } from "react-bootstrap-icons";
interface CaseDetailsProps {
  onFormSubmit: any;
  logUploadFiles: any;
  uploadFiles: any
}

type FormDetails = typeof defaultCaseDeatilsFormDetails;

const CaseDetails = forwardRef((props: CaseDetailsProps, ref) => {
  const { t } = useTranslation();
  const { onFormSubmit, uploadFiles, logUploadFiles } = props;
  const { caseInfo } = useAppSelector(
    (state: RootState) => state.createCaseAPI
  );
  const { productInfo } = useAppSelector(
    (state: RootState) => state.createCaseAPI
  );
  const { addToast } = useToast();
  const dispatch = useAppDispatch();
  const caseDetailsFormData = useAppSelector(
    (state: any) => state.caseDetailsform.formData
  );
  const caseContactChildRef = useRef<submitFormRef>(null);

  const [totalUploadFiles, setTotalUploadFiles] = React.useState<FileData[]>([]);
  const [totalUploadLogFiles, setTotalUploadLogFiles] = React.useState<FileData[]>([]);
  const [allIssueSuggestions, setAllIssueSuggestions] = useState<any>([]);
  const [staticIndent, setStaticIndent] = useState<any>([]);
  const [debounced, setDebounced] = useState("");
  const [progressLoader, setProgressLoader] = useState(false);
  const [uidsCounter, setUidsCounter] = useState(1);
  const [isErrorCodeRequired, setIsErrorCodeRequired] = useState(false);
  const [isUEFILoder, setIsUEFILoder] = useState(false);
  const [validationStatus, setValidationStatus] = useState<'valid' | 'invalid' | null>(null);
  const errorTooTipData = (
    <div className="col-lg-24 unWrrntyModalContent">
      <p>
        {t("HPI.CreateCase.provideanyerror", {
          defaultValue:
            "Provide any error code displayed on your devices. For computer issues, HP recommends to run Windows PC diagnostics or UEFI diagnostics and if a Failure ID is generated, to include it in this field."
        })}
      </p>

      <p
        dangerouslySetInnerHTML={{
          __html: t("HPI.CreateCase.UEFIToolDownloadLink", {
            defaultValue:
              '<a target="_blank" href="http://www8.hp.com/us/en/campaigns/hpsupportassistant/pc-diags.html">Download HP Hardware Diagnostic tool</a>'
          })
        }}
      />

      <p
        dangerouslySetInnerHTML={{
          __html: t("HPI.CreateCase.downloaddiagnostics", {
            defaultValue:
              '<a target="_blank" href="http://support.hp.com/us-en/document/c03467259">How to download, install and run UEFI diagnostics</a>'
          })
        }}
      />

      <p
        dangerouslySetInnerHTML={{
          __html: t("HPI.createcase.entercode", {
            defaultValue:
              'Error code are generated and displayed on the HP device or display. They are often an outcome of running UEFI diagnostics. Please include any error codes to provide additional information to the HP Support agent.<br/><br/>Examples include:<ul><li>Error code: 0GAF1D--000000-MFGJMA-C0D203</li><li>Please provide the exact error code from HP Hardware Diagnostics as shown on the Diagnostics result. Example: <strong>Error code: AB‑12‑CD‑34‑EF</strong>. This will help us provide improved downstream data quality, accurate routing, enhanced case engagement and diagnostic insights.</li></ul>'
          })
        }}
      />
    </div>
  );

  useEffect(() => {
    setTotalUploadFiles(uploadFiles)
    setTotalUploadLogFiles(logUploadFiles)

  }, [uploadFiles])

  const requiredFields = [
    "CaseSubject",
    "IssueDescription",
    "TroubleshootingStepsTaken",
  ];
  let isPoly = sessionStorage.getItem("isPoly");
  let maxFilesSize = isPoly === "true" ? "2GB" : "32MB";
  let maxFiles = "3 files ";
  const [caseWarrantyStatus, setCaseWarrantyStatus] = useState<string>("");
  const [popupTilte, setPopupTitle] = useState<string>("");
  const [open, setOpen] = useState(false);
  const [isAdp, setIsAdp] = useState(false);
  const [
    operatingSystemVersionDetailsJson,
    setOperatingSystemVersionDetailsJson,
  ] = useState<any>([]);

  const [applicationInformationVersion, setApplicationInformationVersion] =
    useState<any>([]);

  const [formDetails, setFormDetails] =
    useState<FormDetails>(caseDetailsFormData);
  const [errors, setErrors] = useState<typeof defaultCaseDeatilsFormDetails>(
    defaultCaseDeatilsFormDetails
  );

  const headerTitle = t('HPI.CreateCase.CaseDetails', { defaultValue: 'Case Information' })
  useEffect(() => {
    setIsAdp(false) // default value
    sessionStorage.setItem("isADP", "false");
    sessionStorage.setItem("isPC", "false");
    if (productInfo?.IsADPRequired) {
      setIsAdp(productInfo?.IsADPRequired)
      sessionStorage.setItem("isADP", "true");
    }

    productInfo?.isPCDevice ? sessionStorage.setItem("isPC", "true") : sessionStorage.setItem("isPC", "false");
    
    const isCustomerAvailability = (() => {
      try {
        return (
          productInfo?.customerAvailabilityDetails != null &&
          JSON.parse(productInfo.customerAvailabilityDetails)?.IsApplicable !== -1
        );
      } catch {
        return false;
      }
    })();

    sessionStorage.setItem("isCustomerAvailability", String(isCustomerAvailability));
    if (productInfo?.ISResponse) {
      try {
        const parsedResponse = JSON.parse(productInfo.ISResponse);
        const caseStatus = parsedResponse?.[0]?.Assets?.[0]?.ContractEntitlement?.[0]?.Status || null;
        setCaseWarrantyStatus(caseStatus);
      } catch (error) {
        console.error("Error parsing ISResponse:", error);
      }
    }
  }, [productInfo]);

  const isRMA = sessionStorage.getItem("isRMA") === "true";

  const showPolyFields = useMemo(() => isRMA && caseWarrantyStatus === "Active", [isRMA, caseWarrantyStatus]);

  const parsePayload = (payloadData: any, defaultLabel: string) => {
    return payloadData
      ? [
        { label: defaultLabel, value: "" },
        ...payloadData.map(
          ({ Value, Key }: { Value: string; Key: string }) => ({
            label: Value,
            value: Key,
          })
        ),
      ]
      : [];
  };

  const fetchVersionIfValid = (
    data: string[],
    fetchFunction: (value: { label: string; value: string }) => void
  ) => {
    if (Array.isArray(data) && data.length > 0 && data[0] !== "") {
      fetchFunction({ label: "", value: data[0] });
    }
  };

  useEffect(() => {
    getStaticIndented();
    fetchVersionIfValid(
      caseDetailsFormData.OperatingSystem,
      fetchOperatingSystemVersion
    );
    fetchVersionIfValid(
      caseDetailsFormData.CaseApplicationInformation,
      fetchApplicationInformationVersion
    );
  }, []);

  useEffect(() => {
    setFormDetails(caseDetailsFormData);
  }, [caseDetailsFormData]);
  const isEmpty = (value: any) => {
  if (value === null || value === undefined) return true;
  if (Array.isArray(value)) {
    return value.length === 0 || !value[0] || value[0] === "";
  }
  if (typeof value === "string") {
    return value.trim() === "";
  }
  return false;
  };
  const validate = (name: string, value: any) => {
    let error = "";
    if (name === "CaseSubject" && requiredFields.includes(name) &&
      (
        !value ||
        (Array.isArray(value) && (value.length === 0 || !value[0]))
      )
    ) {
      error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' });
    }
    else if (!value && requiredFields.includes(name)) {
      error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' });
    }
    if (!value && requiredFields.includes(name)) {
      error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' });
    }
    // if (value.length < 50 && name === "IssueDescription") {
    //   setFormDetails((prevData) => ({
    //     ...prevData,
    //     ['issueSuggestions']: [],
    //   }));
    //   error = t('HPI.ErrorMessage.50MinLength', { defaultValue: 'Enter minimum 50 characters.' });
    // }
    if (value?.length >= 1000 &&  (name === "IssueDescription" || name === "TroubleshootingStepsTaken")) { 
      error = t('HPI.ErrorMessage.1000MaxLength', { defaultValue: 'Maximum allowed length is 1000 characters.' });
    }

    // if (name === "CaseSubject" && !isContainsLettersNumbersSpacesCaseTitle(value)) {
    //   error = "The special characters are not allowed.";
    // }

    // if (name === "ErrorCodes" && !isContainsLettersNumbersSpaces(value)) {
    //   error = "The special characters are not allowed.";
    // }

    // if (name === "ApplicationInformationVersionText" && !IsAlphabeticCharactersSpacesHyphen(value)) {
    //   error = "The special characters are not allowed.";
    // }

    // if (
    //   name === "CustomerTrackingNumber" &&
    //   !IsAlphabeticCharactersSpacesHyphen(value)
    // ) {
    //   error = "The special characters are not allowed.";
    // }

    if (
      name === "ProblemDescription" &&
      formDetails.Adpvalue === "Yes" &&
      (!value || value.trim() === "")
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }
    
    if (
      name === "AccidentOccur" &&
      formDetails.Adpvalue === "Yes" &&
      isEmpty(value)
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }
    

    if (
      name === "ConditionsDamage" &&
      formDetails.Adpvalue === "Yes" &&
      (!value || value.trim() === "")
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }
    
    if (
      name === "dateOfIncident" &&
      formDetails.Adpvalue === "Yes" &&
      isEmpty(value)
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }
     if (
      name === "WhatKindOfAccidentOccured" &&
       formDetails.Adpvalue === "Yes" &&
      (!value || (Array.isArray(value) && (value.length === 0 || value[0] === "")))
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }
    if (
      name === "IsADPCoverage" &&
      formDetails.Adpvalue === "Yes" &&
      (!value || value.trim() === "")
    ) { error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' }) }

    setErrors((prevState) => ({
      ...prevState,
      [name]: error,
    }));
    return error === "";
  };

  const handleSubmit = () => {
    let isValid = true;
    let firstErrorField: string | null = null;
    let errorText = "";
    requiredFields.forEach((field) => {
      const value = formDetails[field as keyof typeof formDetails];
      const fieldValid = validate(field, value);
      if (!fieldValid) {
        isValid = false;
        if (!firstErrorField) {
          firstErrorField = field;
        }
      }
    });
    if (!isValid) {
      scrollToErrorField(firstErrorField);
    }
    if (formDetails.Adpvalue === "Yes") {
      scrollToErrorField(firstErrorField);
      const problemDescriptionValid = validate(
        "ProblemDescription",
        formDetails.ProblemDescription
      );
       const whatKindValid = validate(
        "WhatKindOfAccidentOccured",
        formDetails.WhatKindOfAccidentOccured
      );
      if (!whatKindValid) {
        isValid = false;
      }
      if (!problemDescriptionValid) {
        isValid = false;
      }
      console.log(problemDescriptionValid,);
      if(isAdp === true){
      const AccidentOccurValid = validate(
        "AccidentOccur",
        formDetails.AccidentOccur
      );
      if (!AccidentOccurValid) {
        isValid = false;
      }
      //
      const ConditionsDamageValid = validate(
        "ConditionsDamage",
        formDetails.ConditionsDamage
      );
      if (!ConditionsDamageValid) {
        isValid = false;
      }
      const dateOfIncidentValid = validate(
          "dateOfIncident",
          formDetails.dateOfIncident
      );
      if (!dateOfIncidentValid) {
        isValid = false;
      }
      const isADPCoverageValid = validate(
        "IsADPCoverage",
        formDetails.IsADPCoverage
      );
      if (!isADPCoverageValid) {
        isValid = false;
      }
    }
    }
    
    if (isValid) {
      dispatch(setFormData({ ...formDetails }));
      onFormSubmit(totalUploadFiles, totalUploadLogFiles);
    } else {
      //toast.error(t('HPI.ErrorMessage.FillRequiredFields', { defaultValue: 'Please fill the required fields of case details' }));
      return { isValid: false, errorText: "Please fill the required field" };
    }
    return { isValid, errorText };
  };

  const onSelectChangeHandler = (selectedOption: any, k: any) => {
    setFormDetails((prevData) => ({
      ...prevData,
      [k]: [selectedOption?.value],
    }));
    if (selectedOption?.value && selectedOption.value !== "") {
      if (k === "CaseSubject") {
        if (selectedOption?.IsErrorCodeRequired) {
         
          setIsErrorCodeRequired(true);
        }else{
          setIsErrorCodeRequired(false);
          setErrors((prevData) => ({
            ...prevData,
            ["ErrorCodes"]: ""          
          })); // reset error code 
        }
      }
      setErrors((prevData) => ({
        ...prevData,
        [k]: ""
      }));
    } else {
      validate(k, selectedOption?.value);
    }
  };

  
  const handleInputChange = (
    v: any,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, value } = event.target;
    setFormDetails((prevData) => ({ ...prevData, [name]: value }));
    validate(name, value);
  };

  const popupHeader = () => {
    return (
      <p className="popup-header">
        <img
          src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
          alt=""
          style={{ height: "46px", width: "auto" }}
        />
        <span>{popupTilte}</span>
      </p>
    );
  };

  const handleCallBack = (title: string) => {
    setPopupTitle(title);
    setOpen(true);
  };

  const radioHandler = (val: any) => {
    setFormDetails((prevData) => ({
      ...prevData,
      ["Adpvalue"]: val.target.value,
      ["WhatKindOfAccidentOccured"]: [""],
      ["ProblemDescription"]: !formDetails.ISTeradeciCall
        ? ""
        : formDetails.ProblemDescription,
    }));
  };

  const adpCoverageHander = (val: any) => {
    setFormDetails((prevData) => ({
      ...prevData,
      ["IsADPCoverage"]: val.target.value
    }));
  };

  const fetchVersionDetails = async (
    url: string,
    payload: any,
    setVersion: React.Dispatch<React.SetStateAction<any>>,
    key: string
  ) => {
    try {

      const response = await apiPost(url, payload);
      if (response.data) {
        const versionData = JSON.parse(
          response.data.operatingSystemVersionDetailsJson ||
          response.data.ApplicationInformationVersionL2DetailsJson
        );
        const versionOptions = parsePayload(versionData, t('HPI.Dropdown.DefaultText', { defaultValue: 'Please select' }));
        setFormDetails((prevData) => ({
          ...prevData,
          [key]: caseDetailsFormData[key],
        }));
        setVersion(versionOptions);
      }
    } catch (error) {
      console.error("Error fetching version details:", error);
    }
  };

  const fetchOperatingSystemVersion = (selectedOption: {
    label: string;
    value: string;
  }) => {
    setOperatingSystemVersionDetailsJson([]);
    setFormDetails((prevData) => ({
      ...prevData,
      ["OperatingSystemVersion"]: [""],
    }));
    if (selectedOption.value) {
      const requestPayload = { "operatingsystemselect": selectedOption.value };
      fetchVersionDetails(
        POST_BIND_APP_VER,
        requestPayload,
        setOperatingSystemVersionDetailsJson,
        "OperatingSystemVersion"
      );
    }
  };

  const fetchApplicationInformationVersion = (selectedOption: any) => {
    setApplicationInformationVersion([]);

    setFormDetails((prevData) => ({
      ...prevData,
      ["ApplicationInformationVersion"]: [""],
    }));

    if (selectedOption.value) {
      const payload = { "applicationinformationl1selected": selectedOption.value };
      fetchVersionDetails(
        POST_BIND_APP_VER2,
        payload,
        setApplicationInformationVersion,
        "ApplicationInformationVersion"
      );
    }
  };

  useImperativeHandle(ref, () => ({
    submitForm: handleSubmit,
  }));

  const radioIsRMAHandler = (val: any) => {
    setFormDetails((prevData) => ({
      ...prevData,
      ["IsRMA"]: val.target.value,
    }));
  };

  const changeFileHandle = (event: React.ChangeEvent<HTMLInputElement>) => {
    let isPoly = sessionStorage.getItem("isPoly");
    const allowedFormat = [
        ".jpeg", ".jpg", ".png", ".doc",
        ".docx", ".ppt", ".pptx", ".xls",
        ".xlsx", ".csv", ".txt", ".pdf",
        ".zip", ".gif", ".bmp", ".tgz",
        ".tar", ".cfg", ".log", ".pbu",
        ".cap", ".pcap", ".dmp", ".gz",
        ".msg", ".gzip", ".m4a", ".m4v",
        ".mov", ".mp3", ".mp4"
    ];

    const files = event.target.files;
    if (!files) return;
    let maxFilesSize =
      isPoly === "true" ? 2 * 1024 * 1024 * 1024 : 32 * 1024 * 1024;
    let maxFiles = 3;
    const selectedFiles: FileData[] = Array.from(files).map((file) => ({
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2),
      type: file.type,
      file,
      sizeValid: file.size <= maxFilesSize,
    }));
    const unSupported = selectedFiles.filter((f) => {
      const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
      return !allowedFormat.includes(extension);
    });
    if (unSupported.length > 0) {
      addToast({
        text: t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats', { defaultValue: 'Some files have unsupported formats' }),
        type: "warning",
        timeout: 15,
        id: 1,
      });
    }
    const validExtensions = selectedFiles.filter((f) => {
      const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
      return allowedFormat.includes(extension);
    });
    if (validExtensions.length > selectedFiles.length) {
      addToast({
        text: t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats', { defaultValue: 'Some files have unsupported formats' }),
        type: "warning",
        timeout: 15,
        id: 1,
      });
      // alert(" Some files have unsupported formats");
      event.target.value = "";
      return;
    }
    const validFiles = validExtensions.filter((f) => f.sizeValid);
    if (validFiles.length < validExtensions.length) {
      addToast({
        text:
          isPoly === "true"
            ? "Some files exceed the 2GB size"
            : t('HPI.ErrorMessage.SomeFilesExceed2MBSize', { defaultValue: 'Some files exceed the 32MB size' }),
        type: "warning",
        timeout: 15,
        id: 1,
      });
      // alert("Some files exceed the 2MB size ");
      event.target.value = "";
      return;
    }
    let totalFiles = [...totalUploadFiles, ...validFiles];
    if (totalFiles.length > maxFiles) {
      addToast({
        text: t('HPI.ErrorMessage.YouCanUploadMaximumOf3Files.', { defaultValue: 'You can upload a maximum of 3 files.' }),
        type: "warning",
        timeout: 15,
        id: 1,
      });
    }
    totalFiles = [...totalUploadFiles, ...validFiles].slice(0, 3);
    setTotalUploadFiles(totalFiles);
    event.target.value = "";
  };

  const uploadLogFilesHandler = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    let isPoly = sessionStorage.getItem("isPoly");
    const allowedFormat = [".zip", ".tar"];

    const files = event.target.files;
    if (!files) return;
    let maxFilesSize =
      isPoly === "true" ? 2 * 1024 * 1024 * 1024 : 32 * 1024 * 1024;
    let maxFiles = 3;
    const selectedFiles: FileData[] = Array.from(files).map((file) => ({
      name: file.name,
      size: (file.size / (1024 * 1024)).toFixed(2),
      type: file.type,
      file,
      sizeValid: file.size <= maxFilesSize,
    }));
    const unSupported = selectedFiles.filter((f) => {
      const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
      return !allowedFormat.includes(extension);
    });
    if (unSupported.length > 0) {
      addToast({
        text: t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats', { defaultValue: 'Some files have unsupported formats' }),
        type: "warning",
        timeout: 15,
        id: 1,
      });
    }
    const validExtensions = selectedFiles.filter((f) => {
      const extension = f.name.slice(f.name.lastIndexOf(".")).toLowerCase();
      return allowedFormat.includes(extension);
    });
    if (validExtensions.length > selectedFiles.length) {
      toast.error(t('HPI.ErrorMessage.SomeFilesHaveUnsupportedFormats', { defaultValue: 'Some files have unsupported formats' }));
      event.target.value = "";
      return;
    }
    const validFiles = validExtensions.filter((f) => f.sizeValid);
    if (validFiles.length < validExtensions.length) {
      toast.error(
        isPoly === "true"
          ? "Some files exceed the 2GB size"
          : t('HPI.ErrorMessage.SomeFilesExceed2MBSize', { defaultValue: 'Some files exceed the 32MB size' }));

      // alert("Some files exceed the 2MB size ");
      event.target.value = "";
      return;
    }
    let totalFiles = [...totalUploadLogFiles, ...validFiles];
    if (totalFiles.length > maxFiles) {
      toast.error(t('HPI.ErrorMessage.YouCanUploadMaximumOf3Files.', { defaultValue: 'You can upload a maximum of 3 files.' }));
    }
    totalFiles = [...totalUploadLogFiles, ...validFiles].slice(0, 3);
    setTotalUploadLogFiles(totalFiles);
    event.target.value = "";
  };

  const removeFile = (index: number) => {
    const updatedFiles = totalUploadFiles.filter((_, i) => i !== index);
    setTotalUploadFiles(updatedFiles);
  };

  const removeLogFile = (index: number) => {
    const updatedFiles = totalUploadLogFiles.filter((_, i) => i !== index);
    setTotalUploadLogFiles(updatedFiles);
  };

  useEffect(() => {
    if (formDetails.UIDS !== false) {
      const timer = setTimeout(() => setDebounced(formDetails.IssueDescription), 500);
      return () => {
        clearTimeout(timer)
        setFormDetails((prevData) => ({
          ...prevData,
          ['UIDS']: false,
        }));
      };
    }
  }, [formDetails.IssueDescription]);

  useEffect(() => {
    if (!formDetails.ErrorCodes) return;

    const timer = setTimeout(() => {
      if (isErrorCodeRequired && productInfo?.isPCDevice){
        checkUefi(formDetails.ErrorCodes);
      }      
    }, 2000); // 2 seconds
    return () => clearTimeout(timer); // cancel if user types again
  }, [formDetails.ErrorCodes]);

  const checkUefi = async (errorCode:string) => {
    try {
      let payload = {
        "Id": errorCode
      }
      setIsUEFILoder(true);
      setValidationStatus(null);
      let uefiCall = await apiPost(POST_UEFI_CODE, payload);
      if (uefiCall?.data) {
        if (uefiCall?.data?.IsValidErrorCode?.IsValid){
          setIsUEFILoder(false);
          setValidationStatus('valid');
          // toast.info(t("HPI.CreateCase.UEFI.valid", {
          //   defaultValue: "Error Code has been validated successfully."}), {
          //   autoClose: 8000, // Longer display duration
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true
          // });
        }
        else{
          setIsUEFILoder(false);
          setValidationStatus('invalid');
          // toast.error(t("HPI.CreateCase.UEFI.Notvalid", { 
          //   defaultValue: "The UEFI error code is incorrect." }), {
          //   autoClose: 8000, // Longer display duration
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true
          // });
        }
      }
    } catch (error) {
      setIsUEFILoder(false);
      setValidationStatus('invalid');
      console.log(error,"error uefi")
    }
  }

  const UIDSCALL = async (issueDescription: string) => {
    const fallbackToRouteToAgent = async (reason: "tooVague" | "apiFailure") => {
      await getInternalIssueDesc();
      setFormDetails((prevData) => {
        const routeToAgent =
          (prevData.issueSuggestions || []).find(
            (item: any) =>
              item?.value?.toLowerCase() === "route to agent" ||
              item?.label?.toLowerCase() === "route to agent",
          ) ||
          staticIndent.find(
            (item: any) =>
              item?.value?.toLowerCase() === "route to agent" ||
              item?.label?.toLowerCase() === "route to agent",
          );

        if (!routeToAgent) {
          return prevData;
        }

        return {
          ...prevData,
          CaseSubject: [routeToAgent.value],
          UIDS: false,
        };
      });

      const isFirstTooVague = reason === "tooVague" && uidsCounter === 1;

      setErrors((prevState) => ({
        ...prevState,
        ["IssueDescription"]: isFirstTooVague
          ? t("HPI.CreateCase.IssueDescription.error", {
              defaultValue: "Refine your issue description for better suggestions."
            })
          : "",
        ["CaseSubject"]: [],
      }));

      if (reason === "tooVague") {
        setUidsCounter((prev) => prev + 1);
      } else {
        setUidsCounter(1);
      }

      setProgressLoader(false);
    };

    try {
      let payload = { "issuedescription": issueDescription?.slice(0, 500) };
      let uilsRes = await apiPost(POST_UIDS_ISSUE_DSC, payload);
      if (uilsRes?.data) {
        let intentData = uilsRes.data.intentData;
        let result = intentData.map((item: any) => ({
          label: item.PredictedIntent,
          IsErrorCodeRequired: checkintendExist(item.PredictedIntent),
          value: item.PredictedIntent
        }));
        const checkToVague = result.some((item: any) => item.label?.toLowerCase() === "too vague" || item.value?.toLowerCase() === "too vague");
        if (checkToVague) {
          await fallbackToRouteToAgent("tooVague");
        } else {
          setErrors((prevState) => ({
            ...prevState,
            ["IssueDescription"]: "",
            ["CaseSubject"]: []
          }));
          setAllIssueSuggestions([...result, ...staticIndent]);
          setFormDetails((prevData) => ({
            ...prevData,
            ['CaseSubject']: result.length > 0 ? [result[0].value] : [""],
            ['issueSuggestions']: [...result, ...staticIndent],
            ['UIDS']: false
          }));
          setUidsCounter(1);
          setProgressLoader(false);
        };
      } else {
        await fallbackToRouteToAgent("apiFailure");
      }
    } catch (error) {
      console.error("Error fetching UIDS data:", error);
      await fallbackToRouteToAgent("apiFailure");
    }
    return [];
  }


  
  const getStaticIndented = async () => { 
    try {
      let response: any = await apiGetWithHeader(GET_STATIC_INTENT);
      if (response.data && response.data.intentData) {
        let data = response.data.intentData;
        let result = data.map((item: any) => ({
          label: item.IntentDescription,
          IsErrorCodeRequired: item.IsErrorCodeRequired ?? false, // need to replece with this key item.IsErrorCodeRequired
          value: item.IntentDescription
        }));
        setStaticIndent([...result])
      }      
    } catch (error) {
      console.error("Error fetching static intent data:", error);
    }

  }
  
  const checkintendExist = (value:string) =>{
    const item = staticIndent.find(
      (issue:any) => issue.value.toLowerCase() === value.toLowerCase()
    );
    setIsErrorCodeRequired(item ? item.IsErrorCodeRequired : false)
    return item ? item.IsErrorCodeRequired : false;
  }

  const getInternalIssueDesc = async () => {
    try {
      let response: any = await apiGetWithHeader(GET_STATIC_INTENT);
      if (response.data && response.data.intentData) {
        let data = response.data.intentData;
        let result = data.map((item: any) => ({
          label: item.IntentDescription,
          IsErrorCodeRequired: item.IsErrorCodeRequired ?? false, // need to replece with this key item.IsErrorCodeRequired 
          value: item.IntentDescription
        }));
        setErrors((prevState) => ({
          ...prevState,
          ["IssueDescription"]: "",
          ["CaseSubject"]: []
        }));
        setFormDetails((prevData) => ({
          ...prevData,
          ['issueSuggestions']: result,
          ['UIDS']: false
        }));
        setAllIssueSuggestions([...result]);
        setStaticIndent([...result])
      }
      setUidsCounter(1);
      setProgressLoader(false);
    } catch (error) {
      setProgressLoader(false);
    }
  }

  useEffect(() => {
    if (debounced) {
      setFormDetails((prevData) => ({
        ...prevData,
        ['issueSuggestions']: [],
      }));
      if (errors.IssueDescription === ""){
        setProgressLoader(true);
        setAllIssueSuggestions([]);
        UIDSCALL(debounced);
      }
     }
  }, [debounced]);
  const handleOnDateChange = (newDate:any) => {
    setFormDetails((prevData) => ({
      ...prevData,
      ['dateOfIncident']: newDate,
    }));
    setErrors((prevState) => ({
      ...prevState,
      ["dateOfIncident"]: ""
    }));

  };
  return (
    <Container fluid className="case-details">
      <Card
        className="card-contact-container"
        background="filled"
        content={
          <form>
            {headerTitle ? (
              <div className="">
                <h4>{headerTitle}</h4>
              </div>
            ) : (
              ""
            )}
            <Row className="mb-3">
              <Col md={6}>
                <label htmlFor="issueDescription" className="label-regular">
                  {t("HPI.CreateCase.Problemdescription", {
                    defaultValue: "Issue Description",
                  })}{" "}
                  <span className="text-danger">*</span>
                </label>
                <TextArea
                  id="IssueDescription"
                  name="IssueDescription"
                  value={formDetails?.IssueDescription}
                  onChange={(v: any, e: any) => {
                    setFormDetails((prevData) => ({
                      ...prevData,
                      ["CaseSubject"]: [],
                      ["UIDS"]: true,
                    }));
                    handleInputChange(v, e);
                  }}
                  maxLength={1000}
                  placeholder={t(
                    "HPI.EditCase.Case.Placeholder.EnterIssueDescription",
                    { defaultValue: "Enter issue description" },
                  )}
                  error={!!errors.IssueDescription}
                  helperText={errors.IssueDescription || ""}
                  required
                />
                <small className="text-muted d-flex mt-2">
                  <span className="caption-small">
                    <IconInfo filled color="#666" size={20} className="mr-1" />
                    {t("HPI.CreateCase.PleaseExplainTheSymptoms", {
                      defaultValue: "Please explain the symptoms",
                    })}
                  </span>
                </small>
              </Col>
            
              <Col md={6}>
                <label htmlFor="troubleshootingSteps" className="label-regular">
                  {t("HPI.CreateCase.troubleshoottaken", {
                    defaultValue: "Troubleshooting Steps Taken",
                  })}{" "}
                  <span className="text-danger">*</span>
                </label>
                <span className="supporting-text">
                  <HelpModalPopup
                    align="start"
                    id="modal-popup"
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.troubleshoottaken", {
                          defaultValue: "Troubleshooting steps taken",
                        }),
                      )
                    }
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html: t("HPI.CreateCase.TSS.Tooltip.Content", {
                          defaultValue: `<p>Provide details of any troubleshooting steps taken, try to include:</p><ul type=\"disc\"><li style=\" list-style-type: disc;\">List of completed diagnostics with results.</li><li style=\" list-style-type: disc;\">Copy and paste the steps performed (or URL) from the troubleshooting tool window.</li><li style=\" list-style-type: disc;\">Did you power off and on again?</li><li style=\" list-style-type: disc;\">What have you done to correct the problem? (reload, reboot, reset)</li><li style=\" list-style-type: disc;\">Were any drivers/firmware updated?</li><li style=\" list-style-type: disc;\">Have you checked with different hardware? (For a no power issue swap the adapter/battery, or for a network issue with a wired connection check with different network cables.)</li><li style=\" list-style-type: disc;\">Has any new software or hardware been added?</li><li style=\" list-style-type: disc;\">Have you performed HP diagnostics on the system?</li></ul>`,
                        }),
                      }}
                    ></div>
                  </HelpModalPopup>
                </span>

                <TextArea
                  id="TroubleshootingStepsTaken"
                  name="TroubleshootingStepsTaken"
                  value={formDetails.TroubleshootingStepsTaken}
                  onChange={(v: any, e: any) => handleInputChange(v, e)}
                  maxLength={1000}
                  placeholder={t(
                    "HPI.CreateCase.Placeholder.EnterTroubleshootingSteps",
                    { defaultValue: "Enter troubleshooting steps" },
                  )}
                  error={!!errors.TroubleshootingStepsTaken}
                  helperText={errors.TroubleshootingStepsTaken || ""}
                  required
                />
                <small className="text-muted d-flex mt-2">
                  <span className="caption-small">
                    <IconInfo filled color="#666" size={20} className="mr-1" />
                    {t("HPI.CreateCase.IncludeAllTroubleshootingSteps", {
                      defaultValue:
                        "Include all troubleshooting steps to avoid HP contacting you.",
                    })}
                  </span>
                </small>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <label className="label-contact">
                  {t("HPI.CreateCase.casetitle", {
                    defaultValue: "Issue(case) intent",
                  })}
                  <span className="text-danger"> *</span>
                </label>
                <span className="supporting-text" style={{ top: "-5px" }}>
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.casetitle", {
                          defaultValue: "Issue(case) intent",
                        }),
                      )
                    }
                  >
                    <p
                      dangerouslySetInnerHTML={{
                        __html: t("HPI.CreateCase.casetitle.rule", {
                          defaultValue:
                            "Please begin by describing your issue. This helps us automatically generate the case intent for you. Include symptoms, error messages, and any recent changes",
                        }),
                      }}
                    />
                  </HelpModalPopup>
                </span>
                {progressLoader ? (
                  <ProgressIndicator appearance="linear" />
                ) : (
                  <Select
                    options={formDetails?.issueSuggestions || []}
                    clearIcon={false}
                    id="CaseSubject"
                    name="CaseSubject"
                    className="CaseSubject-cls textbox"
                    value={formDetails.CaseSubject}
                    placeholder={t("HPI.CreateCase.CaseSubject.PlaceHolader", {
                      defaultValue:
                        "Describe your issue – intent fills automatically",
                    })}
                    showSearch
                    onSearch={(value: any) => {
                      let filtered: any = onSearchDropDown(
                        allIssueSuggestions,
                        value,
                      );
                      let savedContacts: any = [...filtered];
                      setFormDetails((prevData) => ({
                        ...prevData,
                        ["issueSuggestions"]: savedContacts,
                      }));
                    }}
                    required
                    onChange={(selectedOption: any) =>
                      onSelectChangeHandler(selectedOption, "CaseSubject")
                    }
                    helperTextVisibility="auto"
                    {...getFieldError(errors, "CaseSubject")}
                  />
                )}
              </Col>
              <Col md={6}>
                <label className="label-contact">
                  {t("HPI.CreateCase.customertracking", {
                    defaultValue: "Internal customer tracking number",
                  })}
                </label>
                <span className="supporting-text" style={{ top: "-5px" }}>
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.customertracking", {
                          defaultValue: "Internal customer tracking number",
                        }),
                      )
                    }
                  >
                    <p>
                      {t("HPI.CreateCase.Serialnumberentered", {
                        defaultValue:
                          "This field can be used to associate the HP Support Case ID to one used within your company's internal tracking system.",
                      })}
                    </p>
                  </HelpModalPopup>
                </span>
                <TextBox
                  placeholder={t(
                    "HPI.CreateCase.Placeholder.EnterInternalCustomerTrackingNumber",
                    { defaultValue: "Enter internal customer tracking number" },
                  )}
                  separateLabel
                  className="textbox"
                  name="CustomerTrackingNumber"
                  maxLength={50}
                  value={formDetails.CustomerTrackingNumber}
                  onChange={(v: any, e) => handleInputChange(v, e)}
                  error={!!errors.CustomerTrackingNumber}
                  helperText={errors.CustomerTrackingNumber}
                />
              </Col>
            </Row>
            <Row >
              {/* <Col md={6}>
              <label>{t("HPI.CreateCase.CasePriority",{defaultValue:'Case Priority'})}</label>
                <span className="supporting-text" >
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t("HPI.CreateCase.Modal.CasePriority",{defaultValue:"Case priority"}))}
                  >
                    <p dangerouslySetInnerHTML={{__html:t('HPI.CreateCase.Modal.CasePriorityDescription',{defaultValue:`Case priority<ol>\r\n    <li>Critical-Down, Equipment is down</li>\r\n    <li>Critical-Degraded, Repair is needed</li>\r\n    <li>Normal, Equipment is experiencing issues</li>\r\n</ol>`})}}>
                    </p>
                  </HelpModalPopup>
                </span>

                <Select
                  clearIcon={false}
                  placement="bottom"
                  helperTextVisibility="auto"
                  separateLabel
                  className="textbox"
                  options={parsePayload(
                    caseInfo?.CasePriorirty,
                    t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'})
                  )}
                  //label={t("HPI.CreateCase.CasePriority",{defaultValue:'Case Priority'})}
                  name="CasePriority"
                  value={formDetails.CasePriority}
                  onChange={(selectedOption: any) =>
                    onSelectChangeHandler(selectedOption, "CasePriority")
                  }
                />
              </Col> */}
              <Col md={6}>
                <label className="label-contact">
                  {t("HPI.CreateCase.OperatingSystem", {
                    defaultValue: "Operating system/version",
                  })}
                </label>
                <span className="supporting-text" style={{ top: "-5px" }}>
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.OperatingSystem", {
                          defaultValue: "Operating system/version",
                        }),
                      )
                    }
                  >
                    <div>
                      <p>
                        {t("HPI.CreateCase.OperatingSystem.BlueBox", {
                          defaultValue:
                            'Operating system/version: If you have selected operating system as "Other", please provide the operating system version in the problem description field.',
                        })}
                      </p>
                    </div>
                  </HelpModalPopup>
                </span>
                <Select
                  options={parsePayload(
                    caseInfo?.OperatingSystem,
                    t("HPI.Dropdown.DefaultText", {
                      defaultValue: "Please select",
                    }),
                  )}
                  //label="Operating System"
                  name={"OperatingSystem"}
                  value={formDetails.OperatingSystem}
                  clearIcon={false}
                  onChange={(selectedOption: any) => {
                    onSelectChangeHandler(selectedOption, "OperatingSystem");
                    fetchOperatingSystemVersion(selectedOption);
                  }}
                  placement="bottom"
                  helperTextVisibility="auto"
                  separateLabel
                  className="textbox"
                />
              </Col>

              <Col md={6} className="align-content-flex-end">
                <Select
                  options={operatingSystemVersionDetailsJson}
                  label=""
                  name="OperatingSystemVersion"
                  value={formDetails.OperatingSystemVersion}
                  clearIcon={false}
                  onChange={(selectedOption: any) =>
                    onSelectChangeHandler(
                      selectedOption,
                      "OperatingSystemVersion",
                    )
                  }
                  placement="bottom"
                  helperTextVisibility="auto"
                  separateLabel
                  className="textbox"
                />
              </Col>
            </Row>

            <Row >
              {/* <div className="col-md-6 col-lg-3">
                <label>{t("HPI.CreateCase.ErrorCodes",{defaultValue:'Error codes'})}</label>
                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t('HPI.CreateCase.ErrorCodes',{defaultValue:'Error Codes'}))}
                  >
                    <div className="col-lg-24 unWrrntyModalContent">
                      <p>{t('HPI.CreateCase.provideanyerror',{defaultValue:'Provide any error codes displayed on your devices. For computer issues, HP recommends to run Windows PC diagnostics or UEFI diagnostics and if a Failure ID is generated, to include it in this field.'})}
                        <p dangerouslySetInnerHTML={{__html:t('HPI.CreateCase.UEFIToolDownloadLink',{defaultValue:`<a target=\"_blank\" href=\"http://www8.hp.com/us/en/campaigns/hpsupportassistant/pc-diags.html\">Download HP Hardware Diagnostic tool</a>`})}}>
                        </p>
                        <p dangerouslySetInnerHTML={{__html:t('HPI.CreateCase.downloaddiagnostics',{defaultValue:`<a target=\"_blank\" href=\"http://support.hp.com/us-en/document/c03467259?jumpid=reg_r1002_usen_c-001_title_r0001%20%20%20\">How to download, install and run UEFI diagnostics</a>`})}}>
                        </p>
                      </p>
                      <p dangerouslySetInnerHTML={{__html:t('HPI.createcase.entercode',{defaultValue:`Error codes are generated and displayed on the HP device or display. They are often an outcome of running UEFI diagnostics. Please include any error codes to provide additional information to the HP Support agent.<br>\r\n<br>Examples include:<ul type=\"disc\">\r\n<li style=\" list-style-type: disc;\">Error code: 0GAF1D--000000-MFGJMA-C0D203</li>\r\n<li style=\" list-style-type: disc;\">HP Client Security Manager Error 1722</li>\r\n<li style=\" list-style-type: disc;\">Dispaly driver stopped responding and has recovered</li>\r\n</ul>`})}}>
                      </p>
                    </div>
                  </HelpModalPopup>
                </span>

                <TextBox
                 // label={t("HPI.CreateCase.ErrorCodes",{defaultValue:'Error codes'})}
                  placeholder={t('HPI.CreateCase.Placeholder.EnterErrorCodes',{defaultValue:'Enter error code'})}
                  separateLabel
                  className="textbox"
                  name="ErrorCodes"
                  value={formDetails.ErrorCodes}
                  error={!!errors.ErrorCodes}
                  helperText={errors.ErrorCodes}
                  onChange={(v: any, e) => handleInputChange(v, e)}
                />
              </div> */}

              <Col className="col-md-6  ">
                <Select
                  options={parsePayload(
                    caseInfo?.CaseApplicationInformation,
                    t("HPI.Dropdown.DefaultText", {
                      defaultValue: "Please select",
                    }),
                  )}
                  label={t("HPI.CreateCase.ApplicationInformation", {
                    defaultValue: "Application Information",
                  })}
                  name="CaseApplicationInformation"
                  value={formDetails.CaseApplicationInformation}
                  clearIcon={false}
                  onChange={(selectedOption: any) => {
                    onSelectChangeHandler(
                      selectedOption,
                      "CaseApplicationInformation",
                    );
                    fetchApplicationInformationVersion(selectedOption);
                  }}
                  placement="bottom"
                  helperTextVisibility="auto"
                  separateLabel
                  className="textbox"
                />
              </Col>

              <Col className="col-md-6 col-lg-3 align-content-flex-end">
                <Select
                  options={applicationInformationVersion}
                  label=""
                  name="ApplicationInformationVersion"
                  value={formDetails.ApplicationInformationVersion}
                  placement="bottom"
                  separateLabel
                  helperTextVisibility="auto"
                  className="version_drp textbox"
                  clearIcon={false}
                  onChange={(selectedOption: any) =>
                    onSelectChangeHandler(
                      selectedOption,
                      "ApplicationInformationVersion",
                    )
                  }
                />
              </Col>

              <Col className="col-md-6 col-lg-3 ">
                <TextBox
                  label={t("HPI.CreateCase.ApplicationVersion", {
                    defaultValue: "Application Version",
                  })}
                  placeholder={t(
                    "HPI.CreateCase.Placeholder.EnterApplicationVersion",
                    { defaultValue: "Enter application version" },
                  )}
                  separateLabel
                  className="textbox"
                  name="ApplicationInformationVersionText"
                  value={formDetails.ApplicationInformationVersionText}
                  onChange={(v: any, e) => handleInputChange(v, e)}
                  error={!!errors.ApplicationInformationVersionText}
                  helperText={errors.ApplicationInformationVersionText}
                />
              </Col>
            </Row>

            {showPolyFields && (
              <Row>
                <Col md={6}>
                  <label htmlFor="IsRMA" className="label-regular pb-1 textbox">
                    Do you need to exchange your products for a replacement?
                  </label>
                  <RadioGroup
                    alignment="horizontal"
                    id="IsRMA"
                    name="IsRMA"
                    defaultValue={formDetails.IsRMA}
                  >
                    <RadioButton
                      value="no"
                      label="No"
                      onClick={(value) => radioIsRMAHandler(value)}
                    />
                    <RadioButton
                      value="yes"
                      label="Yes"
                      onClick={(value) => radioIsRMAHandler(value)}
                    />
                  </RadioGroup>
                </Col>

                <Col md={6}>
                  <TextBox
                    label="Software Release"
                    placeholder="Enter Software Release"
                    separateLabel
                    disabled={formDetails.IsRMA === "no"}
                    className="textbox"
                    name="SoftwareRelease"
                    value={formDetails.SoftwareRelease}
                    onChange={(v: any, e) => handleInputChange(v, e)}
                  />
                </Col>
              </Row>
            )}

            <div className="row rg-2">
              <div className="col-md-6 ">
                <label>
                  {t("HPI.CreateCase.ErrorCodes", {
                    defaultValue: "Error code",
                  })}
                </label>
                <span className="supporting-text">
                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() =>
                      handleCallBack(
                        t("HPI.CreateCase.ErrorCodes", {
                          defaultValue: "Error Code",
                        }),
                      )
                    }
                  >
                    {errorTooTipData}
                  </HelpModalPopup>
                </span>
                {isUEFILoder && (
                  <div className="loader">
                    <ProgressIndicator
                      appearance="circular"
                      behavior="indeterminate"
                      size="small"
                    />
                  </div>
                )}
                <TextBox
                  placeholder={t("HPI.CreateCase.Placeholder.EnterErrorCodes", {
                    defaultValue: "Enter error code",
                  })}
                  separateLabel
                  className="textbox"
                  name="ErrorCodes"
                  value={formDetails.ErrorCodes}
                  error={!!errors.ErrorCodes}
                  readOnly={isUEFILoder ?? false}
                  helperText={errors.ErrorCodes}
                  maxLength={100}
                  onChange={(v: any, e) => {
                    handleInputChange(v, e);
                    setValidationStatus(null); // Clear validation status when user types
                  }}
                />

                {/* Inline Validation Feedback */}
                {validationStatus && (
                  <div >
                    <InlineNotification
                      hideIcon={true}
                      closeButton={false}
                      customStyle={{
                        marginTop: "-15px",
                        marginBottom: "15px",
                        width: "100%",
                        border: validationStatus === 'valid' ? '2px solid #10b981' : '2px solid #ef4444',
                        backgroundColor: validationStatus === 'valid' ? '#ecfdf5' : '#fef2f2',
                        fontWeight: 'bold',
                        fontSize: '14px'
                      }}
                      description={
                        <div style={{ 
                          display: 'flex', 
                          alignItems: 'center',
                          color: validationStatus === 'valid' ? '#065f46' : '#991b1b',
                          fontWeight: 'bold'
                        }}>
                          <span style={{ 
                            marginRight: '8px',
                            fontSize: '16px'
                          }}>
                            {validationStatus === 'valid' ? '✓' : '✗'}
                          </span>
                          <span>
                            {validationStatus === 'valid' 
                              ? t("HPI.CreateCase.UEFI.valid", {
                                  defaultValue: "Error Code has been validated successfully."
                                })
                              : t("HPI.CreateCase.UEFI.Notvalid", { 
                                defaultValue: "Error Code validation failed." 
                                })
                            }
                          </span>
                        </div>
                      }
                    />
                  </div>
                )}
                
                
                {(isErrorCodeRequired && productInfo?.isPCDevice) &&  (
               
                  <InlineNotification
                    closeButton={false}
                    customStyle={{
                      width: "100%",
                      marginTop: validationStatus === null ? "-15px" : "-8px",
                      marginBottom: "15px",
                    }}
                    description={
                      <>
                        <div>
                          {t("HPI.CreateCase.UEFIerror", {
                            defaultValue:
                              "To help us resolve your issue faster, please enter the UEFI error code in this format: 0GAF1D-000000-MFGJMA-C0D203",
                          })}
                        </div>

                        <div style={{ marginTop: "5px" }}>
                          <HelpModalPopup
                            align="start"
                            id="modal-popup"
                            show={open}
                            IconHide={true}
                            IconText={
                              <span
                                style={{
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                {t("HPI.CreateCase.NotSureFindIt", {
                                  defaultValue: "Not sure where to find it?",
                                })}
                              </span>
                            }
                            onClose={() => setOpen(false)}
                            title={popupHeader()}
                            callback={() =>
                              handleCallBack(
                                t("HPI.CreateCase.ErrorCodes", {
                                  defaultValue: "Error Code",
                                }),
                              )
                            }
                          >
                            {errorTooTipData}
                          </HelpModalPopup>
                        </div>
                      </>
                    }
                    type="help"
                  />
                )}
                {/* <p
                  className="label-regular mb-3 text-primary"
                  id="small-caption"
                >
                  {t("HPI.CreateCase.UEFIFormat", {
                    defaultValue: 'To help us resolve your issue faster, please enter the UEFI error code in this format: 0GAF1D--000000-MFGJMA - C0D203' })}
                  
                  <br/>

                  <HelpModalPopup
                    align={"start"}
                    id={"modal-popup"}
                    show={open}
                    IconHide={true}
                    IconText={
                      t("HPI.CreateCase.NotSureFindIt", {
                          defaultValue: "Not sure where to find it?"
                        })
                    }
                    onClose={() => setOpen(false)}
                    title={popupHeader()}
                    callback={() => handleCallBack(t('HPI.CreateCase.ErrorCodes', { defaultValue: 'Error Codes' }))}
                  >
                    <div className="col-lg-24 unWrrntyModalContent">
                      <p>{t('HPI.CreateCase.provideanyerror', { defaultValue: 'Provide any error codes displayed on your devices. For computer issues, HP recommends to run Windows PC diagnostics or UEFI diagnostics and if a Failure ID is generated, to include it in this field.' })}
                        <p dangerouslySetInnerHTML={{ __html: t('HPI.CreateCase.UEFIToolDownloadLink', { defaultValue: `<a target=\"_blank\" href=\"http://www8.hp.com/us/en/campaigns/hpsupportassistant/pc-diags.html\">Download HP Hardware Diagnostic tool</a>` }) }}>
                        </p>
                        <p dangerouslySetInnerHTML={{ __html: t('HPI.CreateCase.downloaddiagnostics', { defaultValue: `<a target=\"_blank\" href=\"http://support.hp.com/us-en/document/c03467259?jumpid=reg_r1002_usen_c-001_title_r0001%20%20%20\">How to download, install and run UEFI diagnostics</a>` }) }}>
                        </p>
                      </p>
                      <p dangerouslySetInnerHTML={{ __html: t('HPI.createcase.entercode', { defaultValue: `Error codes are generated and displayed on the HP device or display. They are often an outcome of running UEFI diagnostics. Please include any error codes to provide additional information to the HP Support agent.<br>\r\n<br>Examples include:<ul type=\"disc\">\r\n<li style=\" list-style-type: disc;\">Error code: 0GAF1D--000000-MFGJMA-C0D203</li>\r\n</ul>` }) }}>
                      </p>
                    </div>
                  </HelpModalPopup>
                  
                </p> */}
              </div>
            </div>
            <>
              {/* ---------------- ROW 1 ---------------- */}
              <Row className="rg-5 mb-3">

                {/* accidentalDamage */}
                <Col md={6}>
                  <label className="label-regular pb-1">
                    {t("HPI.CreateCase.IstheIssueDuetoAccidentalDamage", {
                      defaultValue: "Is the Issue Due to Accidental Damage?",
                    })}
                  </label>

                  <InlineNotification
                    closeButton={false}
                    customStyle={{ width: "100%", marginBottom: "15px" }}
                    description={
                      <p className="label-regular mb-3 text-primary">
                        {t("HPI.CreateCase.Symtomdetaileddescription1", {
                          defaultValue:
                            "If your product was damaged by accident, a description of the incident and resulting damage is required.",
                        })}
                      </p>
                    }
                    type="help"
                  />

                  <RadioGroup
                    alignment="horizontal"
                    id="accidentalDamage"
                    name="accidentalDamage"
                    defaultValue={formDetails.Adpvalue}
                  >
                    <RadioButton
                      value="No"
                      label="No"
                      onClick={(value) => radioHandler(value)}
                    />
                    <RadioButton
                      value="Yes"
                      label="Yes"
                      onClick={(value) => radioHandler(value)}
                    />
                  </RadioGroup>
                </Col>

                {/* ADP Coverage when isAdp true */}
                {formDetails.Adpvalue === "Yes" && (



                  <Col md={isAdp ? 6 : 6}>
                    <label>
                      {t("HPI.CreateCase.WhatKindOfAccidentOccured", {
                        defaultValue: "What kind of accident occurred?",
                      })}
                      <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={parsePayload(
                        caseInfo?.WhatKindOfAccidentOccured,
                        t("HPI.Dropdown.DefaultText", {
                          defaultValue: "Please select",
                        }),
                      )}
                      value={formDetails.WhatKindOfAccidentOccured}
                      name="WhatKindOfAccidentOccured"
                      placement="bottom"
                      separateLabel
                      helperTextVisibility="auto"
                      clearIcon={false}
                      onChange={(selectedOption: any) =>
                        onSelectChangeHandler(
                          selectedOption,
                          "WhatKindOfAccidentOccured",
                        )
                      }
                      {...getFieldError(errors, "WhatKindOfAccidentOccured")}
                    />
                  </Col>
                )}

                {/* ProblemDescription when isAdp false */}
                {formDetails.Adpvalue === "Yes" && !isAdp && (
                  <Col md={6}>
                    <label className="label-regular">
                      {t("HPI.CreateCase.WhatDamageWasCausedbytheAccident", {
                        defaultValue: "What Damage Was Caused by the Accident?",
                      })}
                      <span className="text-danger">*</span>
                    </label>

                    <TextArea
                      name="ProblemDescription"
                      separateLabel
                      required
                      value={formDetails.ProblemDescription}
                      maxLength={500}
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.DescribeTheDamageAndHow/whenItOccurred",
                        {
                          defaultValue:
                            "Describe the damage and how/when it occurred",
                        }
                      )}
                      onChange={(v: any, e: any) => handleInputChange(v, e)}
                      error={!!errors.ProblemDescription}
                      helperText={errors.ProblemDescription || ""}
                    />
                  </Col>
                )}

              </Row>


              {/* ---------------- ROW 2 ---------------- */}
              {formDetails.Adpvalue === "Yes" && (
                <Row className="mb-3">
                  {formDetails.Adpvalue === "Yes" && isAdp && (
                    <Col md={6}>
                      <label className="label-regular mb-2">
                        {t("HPI.CreateCase.IsADPCoverage", {
                          defaultValue:
                            "Are you using the ADP coverage for this incident?",
                        })}
                        <span className="text-danger">*</span>
                      </label>
                      <br></br>
                      <RadioGroup
                        alignment="horizontal"
                        name="IsADPCoverage"
                        defaultValue={formDetails.IsADPCoverage}
                      >
                        <RadioButton
                          value="No"
                          label="No"
                          onClick={(value) => adpCoverageHander(value)}
                        />
                        <RadioButton
                          value="Yes"
                          label="Yes"
                          onClick={(value) => adpCoverageHander(value)}
                        />
                      </RadioGroup>
                    </Col>
                  )}

                  {formDetails.Adpvalue === "Yes" && isAdp && (
                    <Col md={6} >
                      <label>
                        {t("HPI.CreateCase.dateOfIncident", {
                          defaultValue: "Date of Incident",
                        })}
                        <span className="text-danger">*</span>
                      </label>

                      <DatePicker
                        orientation="horizontal"
                        placeholder="MM/DD/YYYY"
                        separateLabel
                        startDatePlaceholder="MM/DD/YYYY"
                        endDatePlaceholder="MM/DD/YYYY"
                        onChange={handleOnDateChange}
                        startDateLabel="Start Date"
                        name="dateOfIncident"
                        blockFutureDates={true}
                        value={formDetails.dateOfIncident}
                        endDateLabel="End Date"
                        error={!!errors.dateOfIncident}
                        helperText={errors.dateOfIncident || ""}
                        
                      />
                    </Col>
                  )}

                </Row>
              )}


              {/* ---------------- ROW 3 ---------------- */}
              {formDetails.Adpvalue === "Yes" && isAdp && (
                <Row className="mb-3">

                  <Col md={6}>
                    <label className="label-regular">
                      {t("HPI.CreateCase.WhatDamageWasCausedbytheAccident", {
                        defaultValue: "What Damage Was Caused by the Accident?",
                      })}
                      <span className="text-danger">*</span>
                    </label>

                    <TextArea
                      name="ProblemDescription"
                      separateLabel
                      required
                      value={formDetails.ProblemDescription}
                      maxLength={500}
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.DescribeTheDamageAndHow/whenItOccurred",
                        {
                          defaultValue:
                            "Describe the damage and how/when it occurred",
                        }
                      )}
                      onChange={(v: any, e: any) => handleInputChange(v, e)}
                      error={!!errors.ProblemDescription}
                      helperText={errors.ProblemDescription || ""}
                    />
                  </Col>

                  <Col md={6}>
                    <label className="label-regular">
                      {t("HPI.CreateCase.AccidentOccur", {
                        defaultValue: "How Did Accident Occur",
                      })}
                      <span className="text-danger">*</span>
                    </label>

                    <TextArea
                      name="AccidentOccur"
                      separateLabel
                      required
                      value={formDetails.AccidentOccur}
                      maxLength={500}
                      placeholder={t("HPI.CreateCase.Placeholder.AccidentOccur", {
                        defaultValue: "Describe how did accident occur",
                      })}
                      onChange={(v: any, e: any) => handleInputChange(v, e)}
                      error={!!errors.AccidentOccur}
                      helperText={errors.AccidentOccur || ""}
                    />
                  </Col>

                </Row>
              )}


              {/* ---------------- ROW 4 ---------------- */}
              {formDetails.Adpvalue === "Yes" && isAdp && (
                <Row className="mb-3">

                  <Col md={6}>
                    <label className="label-regular">
                      {t("HPI.CreateCase.ConditionsDamage", {
                        defaultValue: "Units Conditions and Damage",
                      })}
                      <span className="text-danger">*</span>
                    </label>

                    <TextArea
                      name="ConditionsDamage"
                      separateLabel
                      required
                      value={formDetails.ConditionsDamage}
                      maxLength={500}
                      placeholder={t(
                        "HPI.CreateCase.Placeholder.ConditionsDamage",
                        {
                          defaultValue:
                            "Describe the Units Conditions and Damage",
                        }
                      )}
                      onChange={(v: any, e: any) => handleInputChange(v, e)}
                      error={!!errors.ConditionsDamage}
                      helperText={errors.ConditionsDamage || ""}
                    />

                  </Col>

                </Row>
              )}
            </>
            <Row className="mb-3">
              <Col md={12}>
                <div>
                  <label className="pb-2">
                    <strong className="Upload_label">
                      {" "}
                      {t("HPI.CreateCase.uploadattachment", {
                        defaultValue: "Upload Attachement",
                      })}
                    </strong>{" "}
                    ( {maxFiles}
                    {t("HPI.CreateCase.Max", { defaultValue: "Max" })} ,
                    {maxFilesSize}{" "}
                    {t("HPI.CreateCase.each", { defaultValue: "each" })})
                    <span className="supporting-text">
                      <HelpModalPopup
                        align={"start"}
                        id={"modal-popup"}
                        show={open}
                        onClose={() => setOpen(false)}
                        title={popupHeader()}
                        callback={() =>
                          handleCallBack(
                            t("HPI.create.digitalfile", {
                              defaultValue: "Upload attachments",
                            }),
                          )
                        }
                      >
                        <div
                          className="upload-attachment-popup"
                          dangerouslySetInnerHTML={{
                            __html: t("HPI.CreateCase.FileList", {
                              defaultValue: `<p>Upload up to 3 attachments that may help the HP Support agent resolve your problem. Examples may include blue screen dumps, IDR log files, and general error code screenshots.</p><p>Files must be less than 32 MB and use one of the following file formats:</p><ul style=\"columns: 3;-webkit-columns: 3;-moz-columns: 3;\" ><li>JPEG</li><li>JPG</li><li>PNG</li><li>DOC</li><li>DOCX</li><li>PPT</li><li>PPTX</li><li>XLS</li><li>XLSX</li><li>CSV</li><li>TXT</li><li>PDF</li><li>ZIP</li><li>GIF</li><li>BMP</li><li ng-show=\"isPoly\">TGZ</li><li ng-show=\"isPoly\">TAR</li><li ng-show=\"isPoly\">CFG</li><li ng-show=\"isPoly\">LOG</li><li ng-show=\"isPoly\">PBU</li><li ng-show=\"isPoly\">CAP</li><li ng-show=\"isPoly\">PCAP</li><li ng-show=\"isPoly\">DMP</li><li ng-show=\"isPoly\">GZ</li><li ng-show=\"isPoly\">MSG</li><li ng-show=\"isPoly\">GZIP</li><li ng-show=\"isPoly\">M4A</li><li ng-show=\"isPoly\">M4V</li><li ng-show=\"isPoly\">MOV</li><li ng-show=\"isPoly\">MP3</li><li ng-show=\"isPoly\">MP4</li></ul><p>Select \"choose file\"</p>\r\n`,
                            }),
                          }}
                        ></div>
                      </HelpModalPopup>
                    </span>
                  </label>
                  {totalUploadFiles.length > 0 && (
                    <ul className="p-l-0">
                      {totalUploadFiles.map((f: any, index: any) => (
                        <li
                          key={index}
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <span>
                            {f.file.name} ({f.size}MB )
                          </span>
                          <button
                            type="button"
                            onClick={() => removeFile(index)}
                            style={{
                              marginLeft: "10px",
                              backgroundColor: "transparent",
                              color: "#0078D4",
                              border: "none",
                              borderRadius: "50%",
                              width: "24px",
                              height: "24px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              fontSize: "16px",
                              fontWeight: "bold",
                            }}
                          >
                            X
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </Col>

              <Col md={6} className="upload-file-picker">
                <FilePicker
                  id="file-picker"
                  trailingButton
                  multiple
                  name="upload_File"
                  className={`${totalUploadFiles.length > 0 ? "upload-label" : ""} Upload_attachment textbox`}
                  placeholder={t("HPI.Profilepage.UploadFile", {
                    defaultValue: "Upload File",
                  })}
                  label={t("HPI.Profilepage.UploadFile", {
                    defaultValue: "Upload File",
                  })}
                  onChange={changeFileHandle}
                  accept=".JPEG,.JPG,.PNG,.DOC,.DOCX,.PPT,.PPTX,.XLS,.XLXS,.CSV,.TXT,.PDF,.ZIP,.GIF,.BMP"
                />
              </Col>
            </Row>
              <InlineNotification
                closeButton={false}
                customStyle={{
                  width: "70%",
                  // marginTop: "-15px",
                  // marginBottom: "15px",
                }}
                description={
                  <p
                    className="label-regular mt-1 text-primary"
                    id="small-caption"
                  >
                    {t("HPI.CreateCase.CaseDetail.uploadnote", {
                      defaultValue:
                        "Kindly attach any relevant files to facilitate a quicker and more accurate resolution of your issue.",
                    })}
                  </p>
                }
                type="help"
              />
            {/* functionality commented on 12/09/2025  */}
            {/* {formDetails.ISTeradeciCall && (
              <Row>
                <Col md={12}>
                  <span className="supporting-text" style={{ left: "330px" }}>
                    <HelpModalPopup
                      align={"start"}
                      id={"modal-popup"}
                      show={open}
                      onClose={() => setOpen(false)}
                      title={popupHeader()}
                      callback={() => handleCallBack("Upload Attachments")}
                    >
                      <div>
                        Upload up to 3 attachments that may help the HP Support
                        agent resolve your problem. Examples may include blue
                        screen dumps, IDR log files, and general error code
                        screenshots. Files must be less than {maxFilesSize} and use one of
                        the following file formats: JPEG
                        JPG
                        PNG
                        DOC
                        DOCX
                        PPT
                        PPTX
                        XLS
                        XLSX
                        CSV
                        TXT
                        PDF
                        ZIP
                        GIF
                        BMP
                        TGZ
                        TAR
                        CFG
                        LOG
                        PBU
                        CAP
                        PCAP
                        DMP
                        GZ
                        MSG
                        GZIP
                        M4A
                        M4V
                        MOV
                        MP3
                        MP4 Select "choose
                        file"
                      </div>
                    </HelpModalPopup>
                  </span>
                  <div>
                    <label className="pb-2">
                      <strong className="Upload_label">
                        {" "}
                        Upload log attachments
                      </strong>{" "}
                      ( {1}
                      Max , {5}MB)
                    </label>
                    {totalUploadLogFiles.length > 0 && (
                      <ul>
                        {totalUploadLogFiles.map((f: any, index: any) => (
                          <li
                            key={index}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>
                              {f.file.name} ({f.size}MB )
                            </span>
                            <button
                              type="button"
                              onClick={() => removeLogFile(index)}
                              style={{
                                marginLeft: "10px",
                                backgroundColor: "transparent",
                                color: "#0078D4",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontSize: "16px",
                                fontWeight: "bold",
                              }}
                            >
                              X
                            </button>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </Col>

                <Col md={6} className="upload-file-picker">
                  <FilePicker
                    id="log-file-picker"
                    trailingButton
                    multiple
                    name="uploadLogFile"
                    className={`${totalUploadLogFiles.length > 0 ? 'upload-label' : ''} Upload_attachment textbox`}
                    placeholder={t('HPI.Profilepage.UploadFile', { defaultValue: 'Upload File' })}
                    label={t('HPI.Profilepage.UploadFile', { defaultValue: 'Upload File' })}
                    onChange={uploadLogFilesHandler}
                    accept=".ZIP,.TAR"
                  />
                </Col>
              </Row>
            )} */}
          </form>
        }
      />
      {/* <Card
        className="card-contact-container"
        background="filled"
        content={
            <CaseContact ref={caseContactChildRef}/>
        }
          /> */}
    </Container>
  );
});

export default CaseDetails;
